import { FetchCommunitiesCountDataProvider } from 'modals/CustomFieldModal/Contexts/FetchCommunitiesCount.data.context';
import { QuerySwitch } from 'components/QuerySwitch';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useTranslation } from 'hooks/useTranslation';
import { CustomFieldsSettingsComponentPropsProvider } from 'pages/Settings/pages/CustomFields/contexts/CustomFieldsSettingsComponent.props.context';
import {
  FetchCustomFieldsDataContext,
  FetchCustomFieldsDataProvider,
} from 'pages/Settings/pages/CustomFields/contexts/FetchCustomFields.data.context';
import { CustomFieldsSettingsComponent } from 'pages/Settings/pages/CustomFields/CustomFieldsSettingsComponent';

export default function CustomFieldsPage() {
  const { t } = useTranslation();
  useDocumentTitle(t('page_titles:SETTINGS'));
  return (
    <FetchCustomFieldsDataProvider>
      <FetchCommunitiesCountDataProvider>
        <QuerySwitch
          context={FetchCustomFieldsDataContext}
          component={() => (
            <CustomFieldsSettingsComponentPropsProvider>
              <CustomFieldsSettingsComponent />
            </CustomFieldsSettingsComponentPropsProvider>
          )}
        />
      </FetchCommunitiesCountDataProvider>
    </FetchCustomFieldsDataProvider>
  );
}
